import React from 'react';

/**
 * The card the chart components in this bead sit on.
 *
 * Same shape as the shared `ui/card` primitive, which now carries the same
 * Midnight & Lavender tokens (deepcontext-fgvn.2). This wrapper stays as the
 * chart-specific home for the axis labels, legend and tables around a chart;
 * consumers outside components/ui that still hard-code light-mode text inside
 * a `Card` are a sibling sweep bead's job, not this one's.
 *
 * In light mode `--surface` is #FFFFFF and `--line` is the same hairline the
 * shared card uses, so nothing shifts visually next to a plain `Card`.
 */
export const ChartCard: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className = '',
}) => <div className={`bg-surface text-ink rounded-xl shadow-md ${className}`}>{children}</div>;

export const ChartCardHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className = '',
}) => <div className={`px-6 py-4 border-b border-line ${className}`}>{children}</div>;

export const ChartCardTitle: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className = '',
}) => <h3 className={`text-lg font-semibold ${className}`}>{children}</h3>;

export const ChartCardContent: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className = '',
}) => <div className={`px-6 py-4 ${className}`}>{children}</div>;

export default ChartCard;
